import Brands from "../components/LandingPage/Brands";
import Testimonials from "../components/LandingPage/Testimonials";
import Delefunktion from "../components/Tutorials/Delefunktion";
import DoctioAssist from "../components/Tutorials/DoctioAssist";
import HeroSection from "../components/Tutorials/HeroSection";
import Klikelementer from "../components/Tutorials/KlikElementer";
import Logik from "../components/Tutorials/Logik";
import OpretFraser from "../components/Tutorials/OpretFraser";
import Overvejelser from "../components/Tutorials/Overvejelser";
import PublicLayout from "../layout/PublicLayout";

export default function Tutorials() {
  return (
    <PublicLayout>
      <HeroSection />
      <OpretFraser />
      <Klikelementer />
      <Delefunktion />
      <DoctioAssist />
      <Overvejelser />
      <Logik />
      <div className="mt-12 md:mt-56">
        <Testimonials />
        <Brands />
      </div>
    </PublicLayout>
  );
}
